import Swal from "sweetalert2";

function success(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "確認", 
  cancelText = "取消", 
  onConfirm = () => {}, 
  onCancel = () => {}, 
  options = null
) {
  switch (btnCount) {
    case 0: {
      const payload = applyAlertOptions({
        title: title,
        html: resolveAlertHtml(content, options, { compact: true }),
        icon: "success",
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        customClass: {
          title: 'fz-20 fw-7',
        }
      }, options);
      return finishAlert(Swal.fire(payload), options, onConfirm, onCancel);
    }
    case 1: {
      const payload = applyAlertOptions({
        title: title,
        html: resolveAlertHtml(content, options),
        icon: "success",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline success-bgc',
        }
      }, options);
      return finishAlert(Swal.fire(payload), options, onConfirm, onCancel);
    }
    case 2: {
      const payload = applyAlertOptions({
        title: title,
        html: resolveAlertHtml(content, options),
        icon: "success",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#4A546B',
        cancelButtonText: cancelText,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline success-bgc',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }, options);
      return finishAlert(Swal.fire(payload), options, onConfirm, onCancel);
    }
    default:
      break;
  }

}

function adjustLoadErrorTitleFor404(title, content) {
  if (title !== "載入失敗") return title;
  const text = String(content ?? "");
  if (text.includes("Request failed with status code 404")) {
    return "載入失敗，找不到資料";
  }
  return title;
}

function error(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "確認", 
  cancelText = "取消", 
  onConfirm = () => {}, 
  onCancel = () => {}, 
) {
  title = adjustLoadErrorTitleFor404(title, content);
  switch (btnCount) {
    case 0:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72 kmb-8">${content}</span>`,
        icon: "error",
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        customClass: {
          title: 'fz-20 fw-7',
        }
      });
      break;
    case 1:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        icon: "error",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline error-bgc',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    case 2:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        icon: "error",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#4A546B',
        cancelButtonText: cancelText,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline error-bgc',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    default:
      break;
  }

}
const WARNING_BLOCK_DISMISS = {
  allowOutsideClick: false,
  allowEscapeKey: false,
};

const DESTRUCTIVE_CONFIRM_STYLE = {
  confirmButtonColor: "#D66565",
  cancelButtonColor: "#6B7280",
  customClass: {
    title: "fz-20 fw-7",
    confirmButton: "no-outline",
    cancelButton: "no-outline",
  },
};

function resolveAlertHtml(
  content, 
  options, 
  { compact = false } = {}
) {
  if (options?.html) {
    return content;
  }
  const className = compact ? "fz-16 tx-72 kmb-8" : "fz-16 tx-72";
  return `<span class="${className}">${content}</span>`;
}

function applyAlertOptions(payload, options) {
  if (!options) {
    return payload;
  }
  if (options.zIndex != null) {
    payload.zIndex = options.zIndex;
  }
  if (options.width != null) {
    payload.width = options.width;
  }
  if (options.customClass) {
    payload.customClass = {
      ...payload.customClass,
      ...options.customClass,
    };
  }
  return payload;
}

function finishAlert(
  chain, 
  options, 
  onConfirm, 
  onCancel
) {
  const handler = (result) => {
    if (result.isConfirmed && typeof onConfirm === "function") {
      onConfirm();
    } else if (typeof onCancel === "function") {
      onCancel();
    }
    return result;
  };

  if (options?.returnPromise) {
    return chain.then(handler);
  }

  chain.then(handler);
}

const resolveWarningHtml = resolveAlertHtml;

function applyWarningOptions(payload, options) {
  const next = applyAlertOptions(payload, options);
  if (options?.timer != null) {
    next.timer = options.timer;
    next.showConfirmButton = false;
    next.showCancelButton = false;
  }
  return next;
}

const finishWarningAlert = finishAlert;

function warning(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "確定", 
  cancelText = "取消", 
  onConfirm = () => {}, 
  onCancel = () => {}, 
  options = null
) {
  switch (btnCount) {
    case 0:
      Swal.fire(applyWarningOptions({
        title: title,
        html: resolveWarningHtml(content, options, { compact: true }),
        icon: "warning",
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        ...WARNING_BLOCK_DISMISS,
        customClass: {
          title: 'fz-20 fw-7',
        }
      }, options));
      break;
    case 1: {
      const payload = applyWarningOptions({
        title: title,
        html: resolveWarningHtml(content, options),
        icon: "warning",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        ...WARNING_BLOCK_DISMISS,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline warning-bgc',
        }
      }, options);
      return finishWarningAlert(Swal.fire(payload), options, onConfirm, onCancel);
    }
    case 2: {
      const payload = applyWarningOptions({
        title: title,
        html: resolveWarningHtml(content, options),
        icon: "warning",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#4A546B',
        cancelButtonText: cancelText,
        ...WARNING_BLOCK_DISMISS,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline warning-bgc',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }, options);
      return finishWarningAlert(Swal.fire(payload), options, onConfirm, onCancel);
    }
    default:
      break;
  }
}

function info(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "確認", 
  cancelText = "取消", 
  onConfirm = null, 
  onCancel = null, 
  styleConfig = null
) {
  switch (btnCount) {
    case 0:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72 kmb-8">${content}</span>`,
        icon: "info",
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        customClass: {
          title: 'fz-20 fw-7',
        }
      });
      break;
    case 1:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        icon: "info",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline info-bgc',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    case 2:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        icon: "info",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#4A546B',
        cancelButtonText: cancelText,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline info-bgc',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    default:
      break;
  }
}

function question(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "確定", 
  cancelText = "取消", 
  onConfirm = null, 
  onCancel = null, 
  thirdButtonText = "", 
  onThirdButton = null, 
) {
  switch (btnCount) {
    case 0:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72 kmb-8">${content}</span>`,
        icon: "question",
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        customClass: {
          title: 'fz-20 fw-7',
        }
      });
      break;
    case 1:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        icon: "question",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline question-bgc',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    case 2:
      Swal.fire({
        title: title,
        html: content ? `<span class="fz-16 tx-72">${content}</span>` : "", // 內容為可選擇的傳入，不需要內容時傳入空字串即可
        icon: "question",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#4A546B',
        cancelButtonText: cancelText,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline question-bgc',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    case 3:
      Swal.fire({
        title: title,
        html: `
        <div style="display: flex; flex-direction: column; gap: 8px;">
          ${content ? `<span class="fz-16 tx-72">${content}</span>` : ""}
          <div class="swal-three-button-container" style="margin-top: 20px; display: flex; gap: 8px; margin-left: auto; margin-right: auto;">
            <button id="confirmButton" class="swal2-styled swal2-confirm no-outline question-bgc">
              ${confirmText}
            </button>
            <button id="thirdButton" class="swal2-styled swal2-confirm no-outline" style="background-color: #28a745; border-color: #28a745;">
              ${thirdButtonText}
            </button>
            <button id="cancelButton" class="swal2-styled swal2-cancel no-outline tx-44 fw-4" style="background-color: transparent;">
              ${cancelText}
            </button>
          </div>
        </div>
        `,
        icon: "question",
        showConfirmButton: false,
        showCancelButton: false,
        customClass: {
          title: 'fz-20 fw-7',
        },
        didOpen: () => {
          document.getElementById('confirmButton').addEventListener('click', () => {
            Swal.close();
            if (typeof onConfirm === 'function') {
              onConfirm();
            }
          });
          document.getElementById('thirdButton').addEventListener('click', () => {
            Swal.close();
            if (typeof onThirdButton === 'function') {
              onThirdButton();
            }
          });
          document.getElementById('cancelButton').addEventListener('click', () => {
            Swal.close();
            if (typeof onCancel === 'function') {
              onCancel();
            }
          });
        }
      });
      break;
    default:
      break;
  }
}

/** Promise 版本的確認視窗；保留 btnCount 參數以相容既有呼叫。 */
function SweetQuestionPromise(
  btnCount,
  title,
  content,
  confirmText,
  cancelText
) {
  let dontShowAgain = false;

  return Swal.fire({
    title,
    html: `<span class="fz-16 tx-72">${content}</span>`,
    icon: "question",
    confirmButtonText: confirmText,
    showConfirmButton: true,
    showCancelButton: btnCount === 2,
    cancelButtonColor: "transparent",
    cancelButtonText: cancelText,
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline question-bgc",
      cancelButton: "no-outline tx-44 fw-4",
    },
    willClose: () => {
      const checkbox = Swal.getHtmlContainer()?.querySelector("#dontShowAgain");
      dontShowAgain = checkbox?.checked ?? false;
    },
  }).then((result) => {
    return {
      isConfirmed: result.isConfirmed,
      dontShowAgain,
    };
  });
}

/** 顯示具備提前確認按鈕的倒數確認視窗。 */
/** 帶輸入驗證的確認視窗（Promise）。 */
function questionInputConfirmPromise({
  title,
  html,
  confirmButtonText = "下一步",
  cancelButtonText = "取消",
  inputId = "swal-confirm-input",
  validationMessage = "輸入內容不符合要求",
  validate,
  focusInput = true,
}) {
  return Swal.fire({
    title,
    html,
    icon: "question",
    showCancelButton: true,
    showDenyButton: false,
    confirmButtonText,
    cancelButtonText,
    cancelButtonColor: "transparent",
    focusConfirm: false,
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline question-bgc",
      cancelButton: "no-outline tx-44 fw-4",
    },
    didOpen: () => {
      if (!focusInput) return;
      document.getElementById(inputId)?.focus();
    },
    preConfirm: () => {
      const el = document.getElementById(inputId);
      const raw = (el?.value || "").trim();
      if (typeof validate === "function" && !validate(raw)) {
        Swal.showValidationMessage(validationMessage);
        return false;
      }
      return raw;
    },
    ...WARNING_BLOCK_DISMISS,
  }).then((result) => ({
    isConfirmed: result.isConfirmed,
    value: result.value ?? "",
  }));
}

/** 分店刪除第一步：輸入確認文字。 */
function confirmBranchDeleteInputPromise() {
  return questionInputConfirmPromise({
    title: "確定要刪除此分店嗎？",
    html: `
      <div class="shop-branch-delete-confirm-body" style="display:flex;flex-direction:column;gap:12px;width:100%;text-align:left;box-sizing:border-box;">
        <p class="fz-16 tx-72" style="margin:0;">確認後將進入與「發送訊息 → 立即傳送」相同的倒數冷靜期（10 秒），倒數結束或按下「確定刪除」後才會真正刪除。</p>
        <div style="display:flex;flex-direction:column;gap:16px;width:100%;justify-content:center;">
          <p class="fz-16 tx-72" style="margin:0;"> 請在下方輸入 <strong>確定刪除分店</strong> 或 <strong>delete branch</strong> 以繼續：</p>
          <input id="branch-delete-confirm-input" type="text" class="swal2-input" placeholder="確定刪除分店 或 delete branch" autocomplete="off" style="width:100%;box-sizing:border-box;margin:0 !important;padding:10px 12px;" />
        </div>
      </div>
    `,
    confirmButtonText: "下一步",
    cancelButtonText: "取消",
    inputId: "branch-delete-confirm-input",
    validationMessage: "請輸入「確定刪除分店」或「delete branch」",
    validate: (raw) =>
      raw === "確定刪除分店" || raw.toLowerCase() === "delete branch",
  });
}

/** 分店預約連結複製視窗。 */
function showBranchReserveUrlAlert({
  branchUrlHtml,
  buttonText = "複製",
  buttonCss = "",
  footerUrlHtml,
  onCopy,
  onDismiss,
}) {
  return Swal.fire({
    title: "你的連結已啟用",
    html: `
      <div class="branchInfo__alert">
        <input type="text" value="${branchUrlHtml}" id="urlInput" readonly/>
        <button type="button" class="copyText ${buttonCss}">${buttonText}</button>
      </div>
    `,
    icon: "success",
    showConfirmButton: false,
    showCancelButton: false,
    footer: `<a href="${footerUrlHtml}" target="_blank" rel="noopener noreferrer" class="btn btn-secondary">前往網站</a>`,
    customClass: {
      title: "fz-20 fw-7",
    },
    didOpen: () => {
      const copyButton = document.querySelector(".copyText");
      const urlInput = document.getElementById("urlInput");
      copyButton?.addEventListener("click", () => {
        urlInput?.select();
        navigator.clipboard.writeText(urlInput?.value || "").then(() => {
          if (copyButton) copyButton.innerText = "已複製";
          onCopy?.();
        });
      });
    },
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.close) {
      onDismiss?.();
    }
  });
}

/** 帶進度條的 info 提示（Promise）。 */
function infoTimed(
  title, 
  text, 
  options = {}
) {
  const {
    timer = 3200,
    timerProgressBar = true,
    showConfirmButton = true,
    confirmButtonText = "確認",
  } = options;

  return Swal.fire({
    icon: "info",
    title,
    text,
    timer,
    timerProgressBar,
    showConfirmButton,
    confirmButtonText,
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline info-bgc",
    },
  });
}

/** 帶進度條的 success 提示（Promise）。 */
function successTimed(
  title, 
  text, 
  options = {}
) {
  const {
    timer = 2200,
    timerProgressBar = true,
    showConfirmButton = false,
  } = options;

  return Swal.fire({
    icon: "success",
    title,
    text,
    timer,
    timerProgressBar,
    showConfirmButton,
    customClass: {
      title: "fz-20 fw-7",
    },
  });
}

/** SweetAlert2 原生 loading spinner（不自動關閉）。 */
function loadingNative(title = "正在啟用") {
  return Swal.fire({
    title,
    timer: 0,
    timerProgressBar: true,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

/** confirm / deny / cancel 三選一（Promise）。 */
function questionWithDenyPromise({
  title,
  html = "",
  confirmButtonText = "確定",
  denyButtonText = "否",
  cancelButtonText = "取消",
  reverseButtons = false,
  icon = undefined,
}) {
  return Swal.fire({
    title,
    html,
    ...(icon ? { icon } : {}),
    showCancelButton: true,
    showDenyButton: true,
    confirmButtonText,
    denyButtonText,
    cancelButtonText,
    reverseButtons,
    customClass: {
      title: "fz-20 fw-7",
      confirmButton:
        icon === "warning"
          ? "no-outline warning-bgc"
          : "no-outline question-bgc",
      denyButton: "no-outline",
      cancelButton: "no-outline tx-ff fw-4",
    },
    ...WARNING_BLOCK_DISMISS,
  });
}

const ALERT_HTML_CONFIRM_CLASS = {
  info: "no-outline info-bgc",
  success: "no-outline success-bgc",
  error: "no-outline error-bgc",
  warning: "no-outline warning-bgc",
  question: "no-outline question-bgc",
};

/** 在 preConfirm 驗證失敗時，於彈窗內顯示紅色錯誤訊息。 */
function showValidationMessage(message) {
  Swal.showValidationMessage(message);
}

/** 清除彈窗內的驗證錯誤訊息（例如使用者修正輸入後）。 */
function resetValidationMessage() {
  Swal.resetValidationMessage();
}

/** 自訂 HTML 的 alert 確認框（Promise）。 */
function alertHtmlPromise({
  icon = "warning",
  title = "",
  html = "",
  confirmButtonText = "確認",
  cancelButtonText = "取消",
  denyButtonText = "否",
  showConfirmButton = true,
  showCancelButton = false,
  showDenyButton = false,
  showCloseButton = false,
  width = null,
  zIndex = null,
  timer = null,
  focusConfirm = undefined,
  preConfirm = undefined,
  didOpen = undefined,
  confirmButtonColor = undefined,
  cancelButtonColor = "#4A546B",
  customClass = {},
  blockDismiss = true,
  /** true 時套用全站「由下淡入／往下淡出」動畫（SWAL_FADE_ANIMATION） */
  animated = false,
} = {}) {
  const payload = {
    title,
    html,
    icon: icon === false ? false : icon,
    showConfirmButton,
    showCancelButton,
    showDenyButton,
    customClass: {
      title: "fz-20 fw-7",
      ...(showConfirmButton
        ? {
            confirmButton:
              ALERT_HTML_CONFIRM_CLASS[icon] || ALERT_HTML_CONFIRM_CLASS.warning,
          }
        : {}),
      ...(showCancelButton ? { cancelButton: "no-outline tx-ff fw-4" } : {}),
      ...(showDenyButton ? { denyButton: "no-outline" } : {}),
      ...customClass,
    },
  };

  if (showConfirmButton) {
    payload.confirmButtonText = confirmButtonText;
  }
  if (showCancelButton) {
    payload.cancelButtonText = cancelButtonText;
    payload.cancelButtonColor = cancelButtonColor;
  }
  if (showDenyButton) {
    payload.denyButtonText = denyButtonText;
  }
  if (showCloseButton) {
    payload.showCloseButton = true;
  }
  if (width != null) {
    payload.width = width;
  }
  if (zIndex != null) {
    payload.zIndex = zIndex;
  }
  if (timer != null) {
    payload.timer = timer;
    payload.showConfirmButton = false;
    payload.showCancelButton = false;
  }
  if (focusConfirm !== undefined) {
    payload.focusConfirm = focusConfirm;
  }
  if (typeof preConfirm === "function") {
    payload.preConfirm = preConfirm;
  }
  if (typeof didOpen === "function") {
    payload.didOpen = didOpen;
  }
  if (confirmButtonColor != null) {
    payload.confirmButtonColor = confirmButtonColor;
  }
  if (blockDismiss) {
    Object.assign(payload, WARNING_BLOCK_DISMISS);
  }
  if (animated) {
    Object.assign(payload, SWAL_FADE_ANIMATION);
  }

  return Swal.fire(payload);
}

/** 自訂 HTML 的 warning 確認框（Promise）。 */
function warningHtmlPromise({
  title = "",
  html = "",
  confirmButtonText = "確認",
  zIndex = null,
} = {}) {
  return warning(1, title, html, confirmButtonText, "取消", null, null, {
    html: true,
    zIndex,
    returnPromise: true,
  });
}

/** 作廢等危險操作：輸入原因（Promise）。 */
function warningTextareaPromptPromise({
  title,
  inputId,
  placeholder = "",
  required = false,
  requiredMessage = "此欄位為必填",
  confirmButtonText = "確定作廢",
  cancelButtonText = "取消",
}) {
  return Swal.fire({
    title,
    html: `
      <div style="display: flex; flex-direction: column; align-items: stretch; width: 100%; padding: 0 16px;">
        <textarea
          id="${inputId}"
          class="swal2-textarea"
          placeholder="${placeholder}"
          style="
            width: 100%;
            min-height: 100px;
            padding: 12px;
            border: 1px solid #d9d9d9;
            border-radius: 6px;
            font-size: 14px;
            resize: vertical;
            box-sizing: border-box;
            margin: 0;
          "
        ></textarea>
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    ...DESTRUCTIVE_CONFIRM_STYLE,
    preConfirm: () => {
      const reasonInput = document.getElementById(inputId);
      const value = reasonInput ? reasonInput.value.trim() : "";
      if (required && !value) {
        Swal.showValidationMessage(requiredMessage);
        return false;
      }
      return value;
    },
    ...WARNING_BLOCK_DISMISS,
  }).then((result) => ({
    isConfirmed: result.isConfirmed,
    value: result.value ?? "",
  }));
}

/** 會員等級：啟用確認（Promise）。 */
function confirmEnableMemberLevelPromise() {
  return Swal.fire({
    title: "是否確定啟用會員等級",
    html: `<span class="fz-16 tx-72">啟用後須分別建置會員等級組件</span>`,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "確定啟用",
    cancelButtonText: "取消",
    cancelButtonColor: "#4A546B",
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline info-bgc",
      cancelButton: "no-outline tx-ff fw-4",
    },
    ...WARNING_BLOCK_DISMISS,
  }).then((result) => ({ isConfirmed: result.isConfirmed }));
}

/** 會員等級：關閉確認（兩段式，Promise）。 */
async function confirmDisableMemberLevelPromise() {
  const first = await Swal.fire({
    title: "是否確定關閉會員等級",
    html: `<span class="fz-16 tx-72">新的消費將不再自動升級</span>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "確定關閉",
    cancelButtonText: "取消",
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline warning-bgc",
      cancelButton: "no-outline tx-ff fw-4",
    },
    ...WARNING_BLOCK_DISMISS,
  });
  if (!first.isConfirmed) return { isConfirmed: false };

  const second = await Swal.fire({
    title: "再次確認關閉會員功能",
    html: `<span class="fz-16 tx-72">請確定與客戶做好良好溝通，避免日後糾紛</span>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "是，我確定要關閉會員功能",
    cancelButtonText: "取消",
    ...DESTRUCTIVE_CONFIRM_STYLE,
    ...WARNING_BLOCK_DISMISS,
  });
  return { isConfirmed: second.isConfirmed };
}

/** 作廢等危險操作：再次確認（Promise）。 */
function destructiveConfirmPromise(title, content = "") {
  return Swal.fire({
    title,
    html: content ? `<span class="fz-16 tx-72">${content}</span>` : undefined,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    ...DESTRUCTIVE_CONFIRM_STYLE,
    ...WARNING_BLOCK_DISMISS,
  }).then((result) => ({
    isConfirmed: result.isConfirmed,
  }));
}

function showCountdownPromise(options = {}) {
  const {
    seconds: totalSeconds = 5,
    title = "確定發送",
    confirmButtonText = "確定發送",
    cancelButtonText = "取消發送",
  } = options;

  return new Promise((resolve) => {
    let secondsLeft = totalSeconds;
    let countInterval;

    Swal.fire({
      title,
      html: `
        <div class="sweet-countdown__container">
          <div class="sweet-countdown__text">倒數</div>
          <div class="sweet-countdown__number" id="countdown">
            ${secondsLeft}
          </div>
          <div class="sweet-countdown__text">秒</div>
        </div>
      `,
      footer: `<button id="sweet-countdown-confirm-btn" class="sweet-countdown-confirm-btn">${confirmButtonText}</button>`,
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText,
      allowOutsideClick: false,
      timer: totalSeconds * 1000,
      timerProgressBar: true,
      customClass: {
        popup: "sweet-countdown-popup",
        cancelButton: "sweet-countdown-cancel-btn",
        title: "sweet-small-title",
        footer: "sweet-countdown-footer",
      },
      didOpen: () => {
        document
          .getElementById("sweet-countdown-confirm-btn")
          ?.addEventListener("click", () => {
            resolve({ isConfirmed: true });
            Swal.close();
          });

        countInterval = setInterval(() => {
          secondsLeft -= 1;
          if (secondsLeft >= 0) {
            const countdownElement =
              Swal.getHtmlContainer()?.querySelector("#countdown");
            if (countdownElement) {
              countdownElement.textContent = secondsLeft;
            }
          }
        }, 1000);
      },
      willClose: () => {
        if (countInterval) clearInterval(countInterval);
      },
    }).then((result) => {
      resolve({
        isConfirmed: result.dismiss === Swal.DismissReason.timer,
      });
    });
  });
}

function noIcon(
  btnCount = 1, 
  title = "", 
  content = "", 
  confirmText = "我了解了", 
  cancelText = "取消", 
  onConfirm = () => { }, 
  onCancel = () => { }, 
) {
  switch (btnCount) {
    case 0:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72 kmb-8">${content}</span>`,
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500,
        customClass: {
          title: 'fz-20 fw-7',
        }
      });
      break;
    case 1:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        confirmButtonText: confirmText,
        showConfirmButton: true,
        confirmButtonColor: '#4A546B',
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    case 2:
      Swal.fire({
        title: title,
        html: `<span class="fz-16 tx-72">${content}</span>`,
        confirmButtonText: confirmText,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#4A546B',
        cancelButtonColor: '#6B7280',
        cancelButtonText: cancelText,
        customClass: {
          title: 'fz-20 fw-7',
          confirmButton: 'no-outline',
          cancelButton: 'no-outline tx-ff fw-4',
        }
      }).then((result) => {
        if (result.isConfirmed && typeof onConfirm === 'function') {
          onConfirm();
        } else if (typeof onCancel === 'function') {
          onCancel();
        }
      });
      break;
    default:
      break;
  }
}
function loading(
  title = "資料上傳中，請稍候", 
  content = "請勿關閉視窗", 
  swalOptions = null
) {
  const payload = {
    html: `
          <div class="${(title === "" && content === "") ? ("kmt-30 kmb-30") : ("kmt-10 kmb-10")}" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div class="swal-loader"></div> 
            ${title !== "" ? (`<p id="swal-loading-title" class="kmt-14 fzl-20 tx-24">${title}</p>`) : ""}
            <div id="swal-loading-detail-main" class="kmt-10 kmb-2 fzl-16 tx-88" style="text-align:center;max-width:320px;line-height:1.5;white-space:pre-line;">${content !== "" ? content : ""}</div>
            <p id="swal-loading-detail-done" class="kmb-4 tx-88" style="display:none;text-align:center;max-width:320px;line-height:1.45;white-space:pre-line;margin:0;font-size:11px;color:#a0a0a0;"></p>
          </div>
      `,
    showConfirmButton: false,
    allowOutsideClick: false,  // 禁止點擊外部區域關閉
    allowEscapeKey: false,     // 禁止按 ESC 關閉
  };
  if (swalOptions && typeof swalOptions === "object") {
    if (swalOptions.customClass) {
      payload.customClass = swalOptions.customClass;
    }
    if (swalOptions.zIndex != null) {
      payload.zIndex = swalOptions.zIndex;
    }
  }
  Swal.fire(payload);
}

/**
 * 更新目前顯示中的 loading 內文（需先呼叫 loading() 且視窗仍開著）
 * @param {string} mainOrFull - 主行；若僅傳此參數則整段顯示於主行並隱藏「已完成」區
 * @param {string} [doneLine] - 傳入時顯示為較小字級的次要行（例如「已完成：…」）；傳空字串則隱藏次要行
 * @param {{ htmlMain?: boolean, title?: string }} [options] - `htmlMain: true` 時主行以 innerHTML 寫入；`title` 可更新 loading 標題列
 */
function updateLoadingDetail(mainOrFull, doneLine, options) {
  const root =
    Swal.getHtmlContainer() ||
    document.querySelector(".swal2-html-container");
  const titleEl =
    document.getElementById("swal-loading-title") ||
    root?.querySelector("#swal-loading-title");
  const mainEl =
    document.getElementById("swal-loading-detail-main") ||
    root?.querySelector("#swal-loading-detail-main");
  const doneEl =
    document.getElementById("swal-loading-detail-done") ||
    root?.querySelector("#swal-loading-detail-done");
  if (!mainEl) return;

  if (options && options.title != null && titleEl) {
    titleEl.textContent = options.title;
  }

  const setMain = (v) => {
    const useHtml = options && options.htmlMain;
    if (useHtml) {
      mainEl.innerHTML = v ?? "";
    } else {
      mainEl.textContent = v ?? "";
    }
  };

  if (arguments.length < 2) {
    setMain(mainOrFull);
    if (doneEl) {
      doneEl.textContent = "";
      doneEl.style.display = "none";
    }
    return;
  }

  setMain(mainOrFull);
  if (doneEl) {
    if (doneLine) {
      doneEl.textContent = doneLine;
      doneEl.style.display = "block";
    } else {
      doneEl.textContent = "";
      doneEl.style.display = "none";
    }
  }
}

function close() {
  Swal.close()
}

/** 是否有 SweetAlert2 彈窗正在顯示（供 Esc 鍵優先關閉 Swal） */
function isSwalVisible() {
  return typeof Swal.isVisible === "function" && Swal.isVisible();
}

// 由下淡入／往下淡出，class 定義於 2-global/_modal-slide-animation.scss
// （勿用 animate.css 的 animate__* class：專案未安裝該套件，套了等於沒動畫）
const SWAL_FADE_ANIMATION = {
  showClass: {
    popup: "swal-modal-slide-up",
  },
  hideClass: {
    popup: "swal-modal-slide-down",
  },
};

/**
 * 轉診／會員操作常用的主題色彈窗（Promise）。
 * 支援自訂 HTML、動畫、橙／綠主題與「查看紀錄」類取消鈕。
 */
function themedAlertPromise({
  icon = "warning",
  iconColor = "#F39D5F",
  title,
  html,
  text,
  confirmButtonText = "確認",
  confirmButtonColor = "#F39D5F",
  showCancelButton = false,
  cancelButtonText = "取消",
  cancelButtonColor = "#f5f5f5",
  reverseButtons = false,
  customCancelButton = false,
  animated = true,
} = {}) {
  const payload = {
    icon,
    iconColor,
    confirmButtonText,
    confirmButtonColor,
    showConfirmButton: true,
    showCancelButton,
  };

  if (html != null) {
    payload.html =
      title != null
        ? `<div>
            <h4 style="color:#242424;font-size:20px;margin-bottom:12px;">${title}</h4>
            ${html}
          </div>`
        : html;
  } else {
    if (title != null) payload.title = title;
    if (text != null) payload.text = text;
  }

  if (showCancelButton) {
    payload.cancelButtonText = cancelButtonText;
    payload.cancelButtonColor = cancelButtonColor;
    payload.reverseButtons = reverseButtons;
    if (customCancelButton) {
      payload.customClass = {
        cancelButton: "swal2-cancel custom-cancel-button",
      };
    }
  }

  if (animated) {
    Object.assign(payload, SWAL_FADE_ANIMATION);
  }

  return Swal.fire(payload);
}

/** 帶備註輸入的確認視窗（callback 版）。 */
function confirmWithNote({
  title,
  text = "",
  confirmText = "確定",
  cancelText = "取消",
  noteRequired = false,
  onConfirm,
}) {
  return Swal.fire({
    title,
    html: `
      <div style="text-align: left;">
        ${text ? `<p class="fz-16 tx-72" style="margin-bottom: 12px;">${text}</p>` : ""}
        <label style="display: block; font-size: 14px; color: #4A546B; margin-bottom: 4px;">
          備註${noteRequired ? ' <span style="color: #e74c3c;">*</span>' : "（選填）"}
        </label>
        <textarea id="swal-note-input" class="swal2-textarea" placeholder="請輸入備註..." style="width: 100%; min-height: 80px; resize: vertical; margin: 0; font-size: 14px;"></textarea>
        ${noteRequired ? '<p id="swal-note-error" style="color: #e74c3c; font-size: 12px; margin-top: 4px; display: none;">備註為必填欄位</p>' : ""}
      </div>
    `,
    icon: "question",
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    cancelButtonColor: "transparent",
    customClass: {
      title: "fz-20 fw-7",
      confirmButton: "no-outline question-bgc",
      cancelButton: "no-outline tx-44 fw-4",
    },
    preConfirm: () => {
      const noteValue =
        document.getElementById("swal-note-input")?.value?.trim() || "";
      if (noteRequired && !noteValue) {
        const errorEl = document.getElementById("swal-note-error");
        if (errorEl) errorEl.style.display = "block";
        return false;
      }
      return noteValue;
    },
    ...WARNING_BLOCK_DISMISS,
  }).then((result) => {
    if (result.isConfirmed && typeof onConfirm === "function") {
      onConfirm(result.value);
    }
  });
}

/**
 * 自訂 HTML 列表選擇器（Promise）。
 * 點選項目回傳 { isConfirmed: true, index }；關閉則 isConfirmed: false。
 */
function showListPickerPromise({
  title,
  html,
  itemSelector = ".product-select-option",
  indexAttribute = "data-index",
  titleClass = "smaller-title",
  popupClass = "product-selection-popup",
}) {
  return new Promise((resolve) => {
    let settled = false;
    const finish = (payload) => {
      if (settled) return;
      settled = true;
      resolve(payload);
    };

    Swal.fire({
      title,
      html,
      showConfirmButton: false,
      showCloseButton: true,
      iconHtml: "",
      iconColor: "transparent",
      customClass: {
        title: titleClass,
        popup: popupClass,
      },
      didOpen: () => {
        const styleId = "swal-list-picker-style";
        if (!document.getElementById(styleId)) {
          const style = document.createElement("style");
          style.id = styleId;
          style.innerHTML = `
            .smaller-title {
              font-size: 20px !important;
              font-weight: normal !important;
            }
          `;
          document.head.appendChild(style);
        }

        document.querySelectorAll(itemSelector).forEach((option) => {
          option.addEventListener("click", () => {
            const index = parseInt(option.getAttribute(indexAttribute), 10);
            finish({ isConfirmed: true, index });
            Swal.close();
          });
          option.addEventListener("mouseenter", () => {
            option.style.backgroundColor = "#dedede";
          });
          option.addEventListener("mouseleave", () => {
            option.style.backgroundColor = "#f9f9f9";
          });
        });
      },
    }).then((result) => {
      if (!settled) {
        finish({ isConfirmed: false, index: null, dismiss: result.dismiss });
      }
    });
  });
}

export {
  success,
  error,
  warning,
  warningHtmlPromise,
  alertHtmlPromise,
  showValidationMessage,
  resetValidationMessage,
  info,
  question,
  SweetQuestionPromise,
  questionInputConfirmPromise,
  confirmBranchDeleteInputPromise,
  showBranchReserveUrlAlert,
  infoTimed,
  successTimed,
  loadingNative,
  questionWithDenyPromise,
  themedAlertPromise,
  confirmWithNote,
  showListPickerPromise,
  warningTextareaPromptPromise,
  confirmEnableMemberLevelPromise,
  confirmDisableMemberLevelPromise,
  destructiveConfirmPromise,
  showCountdownPromise,
  noIcon,
  loading,
  updateLoadingDetail,
  close,
  isSwalVisible,
}